import type { ComponentType } from 'react';

import { AboutYouStep } from './AboutYouStep';
import { LearnStep } from './LearnStep';
import { PermissionsStep } from './PermissionsStep';

export const JOIN_STEP_COMPONENTS: Record<string, ComponentType> = {
  'about-you': AboutYouStep,
  learn: LearnStep,
  permissions: PermissionsStep,
};
